import { ItemType } from '../../../_types/item.ts';
import {
	FallbackImages,
	FallbackImagesSource,
} from '../../../../../../cms-components/blackrock/advisor-center/dynamic-list/model';
import { SeriesItemData } from '../SeriesItemCardProps';
import { SortOrder } from '../../../select/SelectProps';

export const getImageFallbackListByItemType = (
	itemType: ItemType,
	data: FallbackImagesSource
): string[] => {
	const fallbackImages: FallbackImages = {
		ARTICLE: data.articleImageList || [],
		DOCUMENT: data.documentImageList || [],
		default: data.articleImageList || [],
	};
	return fallbackImages[itemType] || fallbackImages.default;
};

export const sortByAuthor = (items: SeriesItemData[], order: SortOrder) => {
	return sortItems((item) => item.authors[0].authorName, items, order);
};

export const sortByPublishedDate = (
	items: SeriesItemData[],
	order: SortOrder
) => {
	const reversedOrderForDate =
		order === SortOrder.ascending ? SortOrder.descending : SortOrder.ascending;
	return sortItems(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		(item) => item.publicationDateAsDate,
		items,
		reversedOrderForDate
	);
};

export const sortBySavedDate = (items: SeriesItemData[], order: SortOrder) => {
	const reversedOrderForDate =
		order === SortOrder.ascending ? SortOrder.descending : SortOrder.ascending;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return sortItems((item) => item.dateOfSave, items, reversedOrderForDate);
};

export const sortItems = (
	selectorFunction: (item: SeriesItemData) => string | number,
	items: SeriesItemData[],
	order: SortOrder
): SeriesItemData[] =>
	items.sort((a, b) => {
		const valueA = selectorFunction(a);
		const valueB = selectorFunction(b);
		const direction = order === SortOrder.ascending ? 1 : -1;

		return valueA === valueB ? 0 : valueA > valueB ? direction : -direction;
	});
